import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useParams} from "react-router-dom";
import {
  Paper,
  Typography,
  IconButton,
  Tooltip,
  Button,
  Modal,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
} from "@material-ui/core";

import AutopaySettings from "../components/AutopaySettings";

import Alert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import TrashIcon from "@material-ui/icons/Delete";
import PlusIcon from "@material-ui/icons/Add";
import CancelIcon from "@material-ui/icons/Cancel";
import { useMediaQuery } from "react-responsive";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import CardIcon from "@material-ui/icons/CreditCard";
import HistoryIcon from "@material-ui/icons/HistoryOutlined";
import WalletIcon from "@material-ui/icons/AccountBalanceWalletOutlined";

import AccountBalanceIcon from "@material-ui/icons/AccountBalance";

import { Context as WalletContext } from "../context/wallet.context.js";
import { Context as AuthContext } from "../context/auth.context";
import { Context as PortalContext } from "../context/portal.context";

import VisaIcon from "../images/visa.png";
import MastercardIcon from "../images/mastercard.png";
import DiscoverIcon from "../images/discover.png";
import AmexIcon from "../images/amex.png";

import AddPaymentType from "./AddPaymentType";

let walletOnly = 0;

let queryString = window.location.search;
let params = new URLSearchParams(queryString);

if (params.has('walletOnly'))
	walletOnly = params.get('walletOnly');

const getCardImg = (type) => {
  switch (type) {
    case "visa":
      return <img alt="card" src={VisaIcon} height={40} />;
    case "mastercard":
    case "mast":
    case "mc":
      return <img alt="card" src={MastercardIcon} height={40} />;
    case "amex":
      return <img alt="card" src={AmexIcon} height={40} />;
    case "discover":
    case "disc":
      return <img alt="card" src={DiscoverIcon} height={40} />;
    case "ach":
      return <AccountBalanceIcon />;
    default:
      return null;
  }
};

const Wallet = () => {
  const [isEditCard, setIsEditCard] = useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [tempAutoPay, setTempAutoPay] = useState(null);
  const [snackOpen, setSnackOpen] = useState(false);
  const [autoDialogOpen, setAutoDialogOpen] = React.useState(false);
  const [currentPaymentType, setCurrentPaymentType] = useState(null);
  const {
    state,
    getWallet,
    toggleModal,
    deletePaymentMethod,
    updateAutoPay,
    updateDefaultPaymentMethod,
  } = useContext(WalletContext);
  const authState = useContext(AuthContext);
  const portalState = useContext(PortalContext);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  // allowing overrides from the portalState
  if (walletOnly != 1 && portalState.state.walletOnly == 1) {
	walletOnly = 1;
  }

  const walletContext = useContext(WalletContext);


  const location = useLocation();
  let { op } = useParams();

  useEffect(() => {
    getWallet({
      merchantID: authState.state.merchantID,
      customerID: authState.state.customerID,
    });
  }, []);

  function handleCloseModal() {
    toggleModal();
  }

  function deletePaymentType() {
    if (currentPaymentType === "ach") {
      deletePaymentMethod({ paymentMethod: "ach" });
      updateDefaultPaymentMethod({ paymentMethod: "CC", state: "on" });
      setDialogOpen(false);
    } else {
      deletePaymentMethod({ paymentMethod: "cc" });
      updateDefaultPaymentMethod({ paymentMethod: "ACH", state: "on" });
      setDialogOpen(false);
    }
  }

  function setAutoPay(checked, paymentType) {
    
    updateAutoPay({
      paymentMethod: paymentType === "ach" ? "ACH" : "CC",
      state: checked ? "on" : "off",
      autopay_reminder_days : walletContext.state.autoPay.autoPaySettings.autopay_reminder_days,
      autopay_pay_advance_days : walletContext.state.autoPay.autoPaySettings.autopay_pay_advance_days,
      autopay_pay_day_of_month : walletContext.state.autoPay.autoPaySettings.autopay_pay_day_of_month,
      autopay_max_amount : walletContext.state.autoPay.autoPaySettings.autopay_max_amount,
      autopay_amount_override : walletContext.state.autoPay.autoPaySettings.autopay_amount_override,
      autopay_start_date : walletContext.state.autoPay.autoPaySettings.autopay_start_date
    });



    handleAutoClose();

    if (checked) {
      setSnackOpen(true);
    }
  }

  function setDefault(checked, paymentType) {
    if (paymentType === "ach") {
      updateDefaultPaymentMethod({
        paymentMethod: "ACH",
        state: checked ? "on" : "off",
      });
    } else {
      updateDefaultPaymentMethod({
        paymentMethod: "CC",
        state: checked ? "on" : "off",
      });
    }
  }

  const handleClickOpen = (type) => {
    setCurrentPaymentType(type);
    setDialogOpen(true);
  };

  const handleClose = () => {
    setCurrentPaymentType(null);
    setDialogOpen(false);
  };

  const handleAutoClose = () => {
    setAutoDialogOpen(false);
    setTempAutoPay(null);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  return (
    <>
      <Paper
        elevation={0}
        style={{
          padding: isTabletOrMobile ? 15 : 40,
          margin: isTabletOrMobile ? 15 : 0,
          marginTop: isTabletOrMobile ? 15 : 40,
          border: "1px solid #e3e6e7",
        }}
      >
        <div style={styles.header}>
          {isTabletOrMobile &&
          (portalState.state.ccEnable || portalState.state.achEnable) ? (
            // <Link
            //   to={{
            //     pathname: "wallet/addPaymentMethod",
            //   }}
            //   style={{ outline: "none", textDecoration: "none" }}
            // >
            //   <Button
            //     variant="contained"
            //     disableElevation
            //     color="secondary"
            //     style={{ color: "white", borderRadius: 20 }}
            //     startIcon={<PlusIcon />}
            //     onClick={() => handleCloseModal()}
            //   >
            //     Add new payment type
            //   </Button>
            // </Link>
            <Button
              variant="contained"
              disableElevation
              color="secondary"
              style={{ color: "white", borderRadius: 20 }}
              startIcon={<PlusIcon />}
              onClick={() => handleCloseModal()}
            >
              <x-lang>Add new payment type</x-lang>
            </Button>
          ) : portalState.state.ccEnable || portalState.state.achEnable ? (
            <Button
              variant="contained"
              disableElevation
              color="secondary"
              style={{ color: "white", borderRadius: 20 }}
              startIcon={<PlusIcon />}
              onClick={() => handleCloseModal()}
            >
              <x-lang>Add new payment type</x-lang>
            </Button>
          ) : null}
        </div>

        {Object.keys(state.wallet).map((paymentOption) => {
          return ((state.wallet[paymentOption].paymentType === "visa" ||
            state.wallet[paymentOption].paymentType === "amex" ||
            state.wallet[paymentOption].paymentType === "mast" ||
            state.wallet[paymentOption].paymentType === "disc" ||
            state.wallet[paymentOption].paymentType === "credit card") &&
            portalState.state.ccEnable) ||
            (state.wallet[paymentOption].paymentType === "ach" &&
              portalState.state.achEnable) ? (
            <div
              style={{
                ...styles.typeContainer,
                flexDirection: isTabletOrMobile ? "column" : "row",
              }}
              key={Math.random()}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: isTabletOrMobile ? "100%" : "30%",
                  alignItems: "center",
                  justifyContent: isTabletOrMobile ? "space-between" : null,
                }}
              >
                <div style={{ width: isTabletOrMobile ? null : 100 }}>
                  {getCardImg(state.wallet[paymentOption].paymentType)}
                </div>
                <Typography style={{ marginLeft: 15 }} variant={"body1"}>
                  {state.wallet[paymentOption].paymentType.toUpperCase()} <x-lang>ending
                  in</x-lang> {state.wallet[paymentOption].acctLastFour}
                </Typography>
              </div>
              {isTabletOrMobile ? (
                <div
                  style={{
                    height: 1,
                    width: "100%",
                    background: "#ddd",
                    marginTop: 15,
                    marginBottom: 15,
                  }}
                />
              ) : null}

              {isTabletOrMobile ? null : (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "10%",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant={"body1"}>
                      {state.wallet[paymentOption].secondary}
                    </Typography>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "20%%",
                      alignItems: "center",
                    }}
                  >
                    <Typography style={{ marginLeft: 50 }} variant={"body1"}>
                      {state.wallet[paymentOption].name}
                    </Typography>
                  </div>
                </>
              )}

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexGrow: 1,
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {portalState.state.allowAutoPay ? (
                    <div
                      style={{
                        marginRight: 50,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        color="primary"
                        style={{
                          marginRight: 15,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          color: "#0078a3",
                        }}
                      >
                        <x-lang>Auto Pay</x-lang>
                      </Typography>
                      <input
                        type="checkbox"
                        checked={state.wallet[paymentOption].autoPay}
                        onChange={(e) => {
                          console.log(e.target.checked);
                          setTempAutoPay({
                            checked: e.target.checked,
                            paymentOption,
                          });

                          if (e.target.checked) {
                            setAutoDialogOpen(true);
                          } else {
                            setAutoPay(e.target.checked, paymentOption);
                          }
                        }}
                      ></input>
                    </div>
                  ) : null}

                  <div
                    style={{
                      marginRight: 50,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      color="primary"
                      style={{
                        marginRight: 15,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <x-lang>Default</x-lang>
                    </Typography>
                    <input
                      type="radio"
                      style={{ margin: 0 }}
                      checked={state.wallet[paymentOption].default}
                      onChange={(e) =>
                        setDefault(
                          e.target.checked,
                          state.wallet[paymentOption].paymentType
                        )
                      }
                    ></input>
                  </div>
                </div>

                {/* <Tooltip title="Edit">
                  <IconButton
                    onClick={() => {
                      setIsEditCard(true);
                      toggleModal(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip> */}
                {isTabletOrMobile ? null : (
                  <Tooltip title="Delete">
                    <IconButton
                      onClick={() =>
                        handleClickOpen(state.wallet[paymentOption].paymentType)
                      }
                    >
                      <TrashIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
              {isTabletOrMobile ? (
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: "100%", marginTop: 15 }}
                  onClick={() =>
                    handleClickOpen(state.wallet[paymentOption].paymentType)
                  }
                >
                  <x-lang>Delete</x-lang>
                </Button>
              ) : null}
            </div>
          ) : (
            ""
          );
        })}
        {/*<div style={styles.creditCardVisa}></div>
		<div style={styles.cardMaster}></div>*/}

        <Modal
          open={state.modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            outline: "none",

            overflow: "auto",
          }}
          isEditCard={isEditCard}
        >
          <Paper
            elevation={3}
            style={{
              background: "white",
              outline: "none",
              borderRadius: 5,
              padding: isTabletOrMobile ? 15 : 25,
              marginTop: isTabletOrMobile ? 120 : 0,
              width: isTabletOrMobile ? "100%" : 450,
              boxSizing: "border-box",
              position: "relative",
              boxSizing: "border-box",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              maxHeight: "100%",
              scrollbarWidth: "none",
            }}
          >
            <IconButton
              style={{
                position: "absolute",
                top: 15,
                right: 15,
                zIndex: 100000000,
              }}
              onClick={handleCloseModal}
            >
              <CancelIcon />
            </IconButton>
            <AddPaymentType wallet={state.wallet} />
          </Paper>
        </Modal>
        <Dialog
          open={dialogOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <x-lang>Are you sure you want to delete this payment method?</x-lang>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
            <x-lang>Cancel</x-lang>
            </Button>
            <Button
              onClick={() => deletePaymentType()}
              color="primary"
              autoFocus
            >
              <x-lang>Delete</x-lang>
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={autoDialogOpen}
          onClose={handleAutoClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Alert
                severity="warning"
                style={{ marginBottom: 25, textAlign: "left" }}
              >
                <b><x-lang>IMPORTANT</x-lang>:</b> <x-lang>Enabling the “Auto Pay” feature will
                automatically trigger a charge to the selected payment method
                for the full amount of any invoice on its due date. This also
                means that any invoices that are past due will also be paid
                immediately. You also agree that you will receive status emails
                regarding your autopay.</x-lang>
              </Alert>
            </DialogContentText>

            <AutopaySettings contextParent="wallet" />
          </DialogContent>

          <DialogActions style={{ marginRight: 15, marginBottom: 25 }}>
            <Button onClick={handleAutoClose} variant="contained">
            <x-lang>Cancel</x-lang>
            </Button>
            <Button
              onClick={() =>
                setAutoPay(
                  tempAutoPay.checked,
                  state.wallet[tempAutoPay.paymentOption].paymentType
                )
              }
              variant="contained"
              color="secondary"
              style={{ color: "white", marginLeft: 25 }}
            >
              <x-lang>Enable Auto Pay</x-lang>
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={snackOpen}
          autoHideDuration={6000}
          onClose={handleSnackClose}
        >
          <Alert onClose={handleSnackClose} severity="success">
          <x-lang>Auto pay enabled!</x-lang>
          </Alert>
        </Snackbar>
        <Snackbar
          open={state.addPaymentSuccess}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
        >
          <Alert onClose={handleSnackClose} severity="success">
          <x-lang>Payment method saved!</x-lang>
          </Alert>
        </Snackbar>
      </Paper>
    </>
  );
};

const styles = {
  typeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    border: "1px solid #e8e8e8 ",
    marginBottom: 15,
    padding: 15,
    borderRadius: 5,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    marginBottom: 25,
  },
  creditCardVisa: {
    height: 200,
    width: 300,
    background: "linear-gradient(to right,#004887,#0078a3)",
    borderRadius: 10,
  },
  cardMaster: {
    height: 200,
    width: 300,
    borderRadius: 10,
    background: "linear-gradient(90deg, #d53369 0%, #daae51 100%)",
  },
};

export default Wallet;
